import { Select } from 'components/common/forms/select';
import onClickOutside from 'react-onclickoutside';
import { compose } from 'redux';

const enhance = compose(onClickOutside);
const SelectContainer = enhance(Select);

export { SelectContainer };
